import { render, staticRenderFns } from "./hunshozjus.vue?vue&type=template&id=6c8a351a&scoped=true&"
import script from "./hunshozjus.vue?vue&type=script&lang=js&"
export * from "./hunshozjus.vue?vue&type=script&lang=js&"
import style0 from "./hunshozjus.vue?vue&type=style&index=0&id=6c8a351a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a351a",
  null
  
)

export default component.exports